import comm_config, { checkfeatureStatus } from "../comm_config";
import comm_imgs from "../comm_imgs";
export default class ConfigHandler {
  constructor() {
    this.cf = false;
    this.turn = false;
    this.pad = false;
    this.epmed = false;
  }
  //功能開關切換
  static isMOBILITY = false; // 是否有mobility功能
  static isVital = false; // 是否有vital功能
  static isKmuh = false; // 是否有大同soap功能
  static isInitialized = false;
  static isIWard = false;
  static isReadOnly() {
    const type = new URLSearchParams(window.location.search).get('type');
    return type === 'R';
  }
  static async initStatus() {
    if (!this.isInitialized) {
      const res = await checkfeatureStatus();
      this.isMOBILITY = res.IS_MOBILITY;
      this.isVital = res.IS_VITAL;
      this.isKmuh = res.IS_KMUH;
      this.isFdaClass = res.FDA_CLASS;
      this.isIWard = res.IS_IWARD;
      this.isInitialized = true;
    }
  }
  static isShowCF() {
    if (comm_config.cf === undefined || comm_config.cf === 0) {
      this.cf = false;
      return false;
    } else {
      this.cf = true;
      return true;
    }
  }
  static isShowEP() {
    if (comm_config.epmed === undefined || comm_config.epmed === 0) {
      this.epmed = false;
      return false;
    } else {
      this.epmed = true;
      return true;
    }
  }
  static isShowAIDC() {
    if (comm_config.turn === undefined || comm_config.turn === 0) {
      this.turn = false;
      return false;
    } else {
      this.turn = true;
      return true;
    }
  }
  static isShowScientech() {
    if (localStorage.getItem('institution') === 'st') {
      return true;
    }
  }
  static layoutControl() {
    const isReadOnly = this.isReadOnly();
    if (comm_config.epmed !== undefined && comm_config.epmed !== 0) {
      return {
        pageNum: 5,
        layoutArr: [
          [comm_imgs.FRONTPAGE, 'NAV_BAR.FRONT_PAGE', true],
          [comm_imgs.RESIDENTS, 'NAV_BAR.RESIDENTS', !isReadOnly],
          [comm_imgs.NURSE, 'NAV_BAR.USERS', !isReadOnly],
          [comm_imgs.DEVICE, 'NAV_BAR.BLOOD_PRESSURE', !isReadOnly],
          [comm_imgs.PAD, 'NAV_BAR.BEDSTEAD', !isReadOnly],
        ],
      };
    } else {
      return {
        pageNum: 4,
        layoutArr: [
          [comm_imgs.FRONTPAGE, 'NAV_BAR.FRONT_PAGE', true],
          [comm_imgs.RESIDENTS, 'NAV_BAR.RESIDENTS', !isReadOnly],
          [comm_imgs.PAD, 'NAV_BAR.PADS', !isReadOnly],
          [comm_imgs.NURSE, 'NAV_BAR.USERS', !isReadOnly],
        ],
      };
    }
  }
  static getBreathDropdown() {
    const list = ['HISTORY_RECORD.SCATTER', 'HISTORY_RECORD.RAW_DATA'];
    if (this.isFdaClass !== 2) {
      list.push('HISTORY_RECORD.MEDICAL_ALERT');
    }
    return list;
  }
  //主要頁面控制
  static async hisRecControl() {
    await this.initStatus();
    if (comm_config.epmed !== undefined && comm_config.epmed !== 0) {
      return {
        pageNum: 5,
        layoutName: ['HISTORY_RECORD.WEIGHT', 'HISTORY_RECORD.BLOOD_PRESSURE', 'HISTORY_RECORD.BEDSTEAD'],
        layoutImg: [comm_imgs.BED_STATE, comm_imgs.EPMED_DC, comm_imgs.AUTO_HISTORY],
        dropDownList: [['HISTORY_RECORD.SCATTER', 'HISTORY_RECORD.RAW_DATA'], [], []],
      };
    } else if (comm_config.turn !== undefined && comm_config.turn !== 0) {
      return {
        pageNum: 5,
        layoutName: ['HISTORY_RECORD.BED_STATUS', 'HISTORY_RECORD.BREATH', 'HISTORY_RECORD.SLEEP', 'HISTORY_RECORD.DIAPER_RECORD', 'HISTORY_RECORD.BED_CHANGE'],
        layoutImg: [comm_imgs.BED_STATE, comm_imgs.VITAL, comm_imgs.SE, comm_imgs.DAIPER, comm_imgs.AUTO_HISTORY],
        dropDownList: [['HISTORY_RECORD.RAW_DATA', 'HISTORY_RECORD.DAILY_CHART', 'HISTORY_RECORD.MONTHLY_REPORT'], ['HISTORY_RECORD.SCATTER', 'HISTORY_RECORD.RAW_DATA', 'HISTORY_RECORD.MEDICAL_ALERT'], [], ['當日排泄', '異常紀錄'], ['HISTORY_RECORD.BED_CHANGE', 'HISTORY_RECORD.AUTO']],
      };
    } else {
      // 根據 isMOBILITY 和 isVital 的組合來決定內容
      let layoutName = ['HISTORY_RECORD.BED_STATUS', 'HISTORY_RECORD.SLEEP'];
      let layoutImg = [comm_imgs.BED_STATE, comm_imgs.SE];
      let dropDownList = [
        ['HISTORY_RECORD.RAW_DATA', 'HISTORY_RECORD.DAILY_CHART', 'HISTORY_RECORD.MONTHLY_REPORT'],
        ['HISTORY_RECORD.SLEEP', 'HISTORY_RECORD.SLEEPCHART', 'HISTORY_RECORD.SLEEP_ANALYSIS'],
      ];

      if (this.isVital) {
        layoutName.splice(1, 0, 'HISTORY_RECORD.BREATH');
        layoutImg.splice(1, 0, comm_imgs.VITAL);
        dropDownList.splice(1, 0, this.getBreathDropdown());
      }

      if (this.isMOBILITY) {
        layoutName.push('HISTORY_RECORD.MOBILITY');
        layoutImg.push(comm_imgs.AUTO_HISTORY);
        dropDownList.push(['HISTORY_RECORD.MOBILITY_CHART', 'HISTORY_RECORD.MOBILITY_DATA', 'HISTORY_RECORD.MOBILITY_ANALYSIS']);
      }

      return {
        pageNum: layoutName.length,
        layoutName,
        layoutImg,
        dropDownList,
      };
    }
  }
  static addControl() {
    if (comm_config.epmed !== undefined && comm_config.epmed !== 0) {
      return {
        pageNum: 5,
        layoutArr: [
          ['', '', false],
          [comm_imgs.RESIDENTS, 'GLOBAL.ADD_RESIDENTS', true],
          [comm_imgs.NURSE, 'GLOBAL.ADD_USERS', true],
          [comm_imgs.DEVICE, 'GLOBAL.ADD_BLOODPRESSURE', true],
          [comm_imgs.PAD, 'GLOBAL.ADD_BEDSTEADS', true],
        ],
      };
    } else {
      return {
        pageNum: 4,
        layoutArr: [
          ['', '', false],
          [comm_imgs.RESIDENTS, 'GLOBAL.ADD_RESIDENTS', true],
          [comm_imgs.PAD, 'GLOBAL.ADD_PADS', true],
          [comm_imgs.NURSE, 'GLOBAL.ADD_USERS', true],
        ],
      };
    }
  }
  static residentHeader(nameSort, bedSort, padSort, usersSort, careItemsSort) {
    if (comm_config.epmed !== undefined && comm_config.epmed !== 0) {
      return {
        headerNum: 3,
        layoutArr: [['name', 'GLOBAL.NAME'], ['bed', 'GLOBAL.BED_NO'][('users', 'NAV_BAR.USERS')]],
      };
    } else {
      return {
        headerNum: 5,
        layoutArr: [['name', 'GLOBAL.NAME', nameSort], ['bed', 'GLOBAL.BED_NO', bedSort][('pad', 'NAV_BAR.PADS', padSort)], ['users', 'NAV_BAR.USERS', usersSort], ['careItems', 'RESIDENTS.CARE_ITEMS', careItemsSort]],
      };
    }
  }
}